import React, { useEffect, useRef, useState } from "react";

const WhyChooseUs = () => {
  // State to manage progress percentages
  const [progress, setProgress] = useState({
    digitalMarketing: 0,
    designBranding: 0,
    socialMediaManagement: 0,
    contentMarketing: 0,
  });

  const sectionRef = useRef(null); // Create a ref for the component

  // Function to handle progress update
  const updateProgress = () => {
    setProgress({
      digitalMarketing: 85,
      designBranding: 87,
      socialMediaManagement: 90,
      contentMarketing: 78,
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          updateProgress(); // Call the update function when the component is in view
          observer.unobserve(sectionRef.current); // Stop observing after the first trigger
        }
      },
      { threshold: 0.4 } // Trigger when 40% of the component is in view
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current); // Start observing the component
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current); // Clean up the observer
      }
    };
  }, [sectionRef]);

  return (
    <div
      ref={sectionRef} // Attach the ref to the main div
      className=" relative w-full pb-10 pt-10 p-8 md:p-10 lg:p-20 flex flex-col md:flex-row items-start justify-between space-y-8 md:space-y-0 sm:px-6 lg:px-20  h-auto "
    >
      {/* Left Section with Image */}
      <div className="relative md:w-1/3 w-full flex justify-center items-start">
        {/* Image placeholder */}
        {/* <img
          src={choosehome}
          alt="Background"
          className="absolute w-full max-w-[500px] h-auto object-cover rounded-lg"
        /> */}

        {/* Progress Bars Overlay */}
        <div className="relative  w-full max-w-[400px] bg-transparent bg-opacity-60 p-6 rounded-lg border-[3px] border-white">
          <div className="mb-4">
            <p className="text-white mb-2 font-semibold">
              Digital Marketing{" "}
              <span className="inline float-right">
                {progress.digitalMarketing}%
              </span>
            </p>
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div
                className="bg-teal-800 h-3 rounded-full transition-all duration-[2s]"
                style={{ width: `${progress.digitalMarketing}%` }}
              />
            </div>
          </div>

          <div className="mb-4">
            <p className="text-white mb-2 font-semibold">
              Design & Branding{" "}
              <span className="inline float-right">
                {progress.designBranding}%
              </span>
            </p>
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div
                className="bg-blue-300 h-3 rounded-full transition-all duration-[2s]"
                style={{ width: `${progress.designBranding}%` }}
              />
            </div>
          </div>

          <div className="mb-4">
            <p className="text-white mb-2 font-semibold">
              Social Media{" "}
              <span className="inline float-right">
                {progress.socialMediaManagement}%
              </span>
            </p>
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div
                className="bg-teal-400 h-3 rounded-full transition-all duration-[2s]"
                style={{ width: `${progress.socialMediaManagement}%` }}
              />
            </div>
          </div>

          <div className="mb-4">
            <p className="text-white font-semibold mb-2">
              Content Marketing{" "}
              <span className="inline float-right">
                {progress.contentMarketing}%
              </span>
            </p>
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div
                className="bg-green-300 h-3 rounded-full transition-all duration-[2s]"
                style={{ width: `${progress.contentMarketing}%` }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Right Section with Text and Buttons */}
      <div className="md:w-2/3 w-full flex flex-col justify-center text-white space-y-6 px-2 md:px-4 lg:px-16 ">
        <div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Creating Experiences, Generating Success Together
          </h2>
          <p className="text-gray-100 text-lg ">
            We’re not just another digital marketing agency — we’re your
            strategic partner in growth. Here’s why businesses choose us to
            elevate their brand:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex items-center">
            <span className="bg-teal-400 w-4 h-4 rounded-full inline-block mr-2" />
            <p className="text-lg font-medium">Tailored Solutions</p>
          </div>

          <div className="flex items-center">
            <span className="bg-green-500 w-4 h-4 rounded-full inline-block mr-2" />
            <p className="text-lg font-medium">Proven Expertise</p>
          </div>

          <div className="flex items-center">
            <span className="bg-green-500 w-4 h-4 rounded-full inline-block mr-2" />
            <p className="text-lg font-medium">Data-Driven Results</p>
          </div>

          <div className="flex items-center">
            <span className="bg-teal-400 w-4 h-4 rounded-full inline-block mr-2" />
            <p className="text-lg font-medium">Innovative Strategies</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
